module.exports = __webpack_public_path__ + "img/top-category-gourmet.23dde9c1.jpg";